import React from 'react';

const ComingSoon = ({ pageTitle }) => (
  <div
    className="coming-soon-page"
    style={{
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1.5rem',
      boxSizing: 'border-box',
      width: '100%',
    }}
  >
    {pageTitle ? (
      <h2
        style={{
          fontSize: 'clamp(1rem, 3.5vw, 1.25rem)',
          color: '#4B5563',
          marginBottom: '0.75rem',
          fontWeight: 600,
          textAlign: 'center',
        }}
      >
        {pageTitle}
      </h2>
    ) : null}
    <h1
      style={{
        fontSize: 'clamp(1.5rem, 5vw, 2rem)',
        color: '#374151',
        marginBottom: '1rem',
        textAlign: 'center',
      }}
    >
      Coming Soon
    </h1>
    <p
      style={{
        color: '#6B7280',
        fontSize: 'clamp(0.95rem, 3vw, 1.1rem)',
        textAlign: 'center',
        maxWidth: '32rem',
        margin: 0,
        lineHeight: 1.5,
      }}
    >
      This page is under construction. Please check back later!
    </p>
  </div>
);

export default ComingSoon;


